import * as React from 'react';
import {useEffect, useState, useRef, createRef, useMemo, useContext} from 'react';
import L, {LatLngExpression, latLngBounds} from 'leaflet';
// import MarkerClusterGroup from 'react-leaflet-markercluster';
// import 'react-leaflet-markercluster/dist/styles.min.css';
import Control from 'react-leaflet-custom-control';
import CloseIcon from '@mui/icons-material/Close';
import CenterFocusWeakIcon from '@mui/icons-material/CenterFocusWeak';
import {ClickAwayListener} from '@mui/base';
import {MapContainer, Marker, TileLayer, Popup, useMapEvents, useMap, Circle, LayersControl} from 'react-leaflet';

// @ts-ignore
import markerParking from '../assets/icons/marker_parking.svg';
// @ts-ignore
// import markerParkingLots from '../assets/icons/marker_parking_lots.svg';
// @ts-ignore
import markerLive from '../assets/icons/marker_live.svg';
// @ts-ignore
import markerShrine from '../assets/icons/marker_shrine.svg';
import {
	useTheme,
	Container,
	Typography,
	Button,
	Slide,
	Paper,
	Fade,
	Box, styled, IconButton, Snackbar, Alert
} from '@mui/material';
import TrapFocus from '@mui/material/Unstable_TrapFocus';
import {useTranslation} from 'react-i18next';
import {useMapContext, TAreaLocations, TLatLng, TParking, LiveFoundObject} from '@context/MapContext';
import {TransitionProps} from '@mui/material/transitions';
import {Link} from 'react-router-dom';
import LocationOn from '@icons/LocationOn';
import LocationOff from '@icons/LocationOff';
// import ShrineIcon from '@icons/ShrineIcon';
// import ParkingLotsMapIcon from '@icons/ParkingLotsListIcon';
import ShareLocationIcon from '@mui/icons-material/ShareLocation';
import ParkingLotsLayer from '@icons/ParkingLotsLayer';
import {useProjectContext} from '@context/ProjectContext';
import {useAnalytics} from 'use-analytics';
// import {renderToStaticMarkup} from 'react-dom/server';
// Leaflet.Icon.Default.mergeOptions({
// 	iconRetinaUrl: markerRetina,
// 	iconUrl: markerIcon,
// 	shadowUrl: markerShadow
// });
const {BaseLayer, Overlay} = LayersControl;
let MarkerParkingIcon = L.icon({
	iconUrl: markerParking,
	// iconRetinaUrl: markerRetina,
	// shadowUrl: markerShadow
	iconSize: [30, 30]
});
let MarkerLiveIcon = L.icon({
	iconUrl: markerLive,
	iconSize: [30, 30]
});
let MarkerShrineIcon = L.icon({
	iconUrl: markerShrine,
	iconSize: [30, 30]
});
type FlagProps = {
	fill: string,
	stroke?: string
}

function FlagLogo({fill, stroke = 'none'}: FlagProps) {
	// 👇️ paste SVG into a component
	// take fill and stroke colors as props
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={stroke} xmlns="http://www.w3.org/2000/svg">
			<path opacity="0.4"
			      d="M13.7467 5.63335C13.0467 2.55335 10.3601 1.16669 8.00006 1.16669H7.9934C5.64006 1.16669 2.94673 2.54669 2.24673 5.62669C1.46673 9.06669 3.5734 11.98 5.48006 13.8134C6.15588 14.4675 7.05953 14.8332 8.00006 14.8334C8.90673 14.8334 9.8134 14.4934 10.5134 13.8134C12.4201 11.98 14.5267 9.07335 13.7467 5.63335Z"
			      fill={fill}/>
			<path
				d="M8.00039 8.97332C8.27617 8.97332 8.54924 8.919 8.80403 8.81346C9.05881 8.70793 9.29031 8.55324 9.48531 8.35824C9.68032 8.16324 9.835 7.93173 9.94054 7.67695C10.0461 7.42217 10.1004 7.14909 10.1004 6.87332C10.1004 6.59754 10.0461 6.32446 9.94054 6.06968C9.835 5.8149 9.68032 5.58339 9.48531 5.38839C9.29031 5.19339 9.05881 5.0387 8.80403 4.93317C8.54924 4.82763 8.27617 4.77332 8.00039 4.77332C7.44344 4.77332 6.90929 4.99457 6.51547 5.38839C6.12164 5.78222 5.90039 6.31636 5.90039 6.87332C5.90039 7.43027 6.12164 7.96441 6.51547 8.35824C6.90929 8.75207 7.44344 8.97332 8.00039 8.97332Z"
				fill="black"/>
		</svg>
	);
}

// let MarkerParkingLotsIcon = L.icon({
// 	iconUrl: markerParkingLots,
// 	iconSize: [30, 30]
// });
let iconSettings = (color: any) => {
	return {
		mapIconUrl: '<svg version="1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 149 178"><path fill="{mapIconColor}" stroke="#FFF" stroke-width="6" stroke-miterlimit="10" d="M126 23l-6-6A69 69 0 0 0 74 1a69 69 0 0 0-51 22A70 70 0 0 0 1 74c0 21 7 38 22 52l43 47c6 6 11 6 16 0l48-51c12-13 18-29 18-48 0-20-8-37-22-51z"/><circle fill="{mapIconColorInnerCircle}" cx="74" cy="75" r="61"/><circle fill="#FFF" cx="74" cy="75" r="{pinInnerCircleRadius}"/></svg>',
		mapIconColor: color,
		mapIconColorInnerCircle: color,
		pinInnerCircleRadius: 40
	};
};
let divLeafletIcon = (color: any, click: boolean) => {
	let icon = iconSettings(color);
	return L.divIcon({
		className: 'leaflet-data-marker',
		html: L.Util.template(icon['mapIconUrl'], icon),
		iconAnchor: [10, 10],
		iconSize: click ? [25, 30] : [20, 25],
		popupAnchor: [0, -28]
	});
};
type TColor = {
	'class': string,
	'color': string,
	'text': string
}
const colors: {
	[key: string]: TColor
} = {
	0: {
		'class': 'bg-black',
		'color': '#000',
		'text': 'full'
	},
	// 10: {
	// 	'class': 'bg-red-500',
	// 	'color': '#de3730'
	// },
	20: {
		'class': 'bg-red-500',
		'color': '#de3730',
		'text': 'close_to_full'
	},
	// 30: {
	// 	'class': 'bg-orange-400',
	// 	'color': '#ffa726',
	// 	'text': 'filling_up'
	// },
	// 100: {
	// 	'class': 'bg-orange-200',
	// 	'color': '#ffcc80'
	// },
	// 200: {
	// 	'class': 'bg-green-300',
	// 	'color': '#81c784'
	// },
	500: {
		'class': 'bg-green-700',
		'color': '#388e3c',
		'text': 'vacant'
	}
	// 1000: {
	// 	'class': 'bg-gray-900',
	// 	'color': '#191b23',
	// 	'text': 'vacant'
	// }
};

function ImamRezaShrineLocation(props: any) {
	const {t} = useTranslation();
	const [bbox, setBbox] = useState([]);
	const {location, markerClicked} = props;
	const shrinePosition: LatLngExpression = [parseFloat(location.y), parseFloat(location.x)];
	// const [position, setPosition] = useState(parkingPosition);
	// const map = useMap();
	// const radius = map.getScaleZoom()
	// const circle = L.circle(e.latlng, radius);
	// circle.addTo(map);
	// map.flyTo(parkingPosition, map.getZoom());
	// const mapEvents = useMapEvents({
	// 	click: () => {
	// 		mapEvents.locate()
	// 	},
	// 	locationfound: (location) => {
	// 		console.log('location found:', location)
	// 	},
	// })
	// return null;
	// useEffect(() => {
	// 	map.locate().on("locationfound", function (e) {
	// 		setPosition(e.latlng);
	// 		map.flyTo(e.latlng, map.getZoom());
	// 		const radius = e.accuracy;
	// 		const circle = L.circle(e.latlng, radius);
	// 		circle.addTo(map);
	// 		setBbox(e.bounds.toBBoxString().split(","));
	// 	});
	// }, [map]);
	
	return (
		<>
			<Marker
				key={'parking_marker'}
				position={shrinePosition}
				draggable={false}
				eventHandlers={{
					//@ts-ignore
					click: event => markerClicked(event, 'shrine', shrinePosition)
				}}
				// ref={markerRef}
				icon={MarkerShrineIcon}
			>
				<Circle
					center={shrinePosition}
					// radius={getRadius(zoom)}
					radius={100}
					pathOptions={{color: '#ffb74d', fillColor: '#ff9800'}}
					stroke={false}
				/>
				{/*<Popup>*/}
				{/*	<Typography*/}
				{/*		gutterBottom*/}
				{/*		variant="h5"*/}
				{/*		component="div"*/}
				{/*		className="font-bold text-center"*/}
				{/*		sx={{*/}
				{/*			color: (theme) => {*/}
				{/*				// @ts-ignore*/}
				{/*				return theme.palette.warning[600];*/}
				{/*			},*/}
				{/*			fontSize: (theme) => theme.typography.fontSize*/}
				{/*		}}*/}
				{/*	>*/}
				{/*		{location.address}*/}
				{/*	</Typography>*/}
				{/*</Popup>*/}
			</Marker>
		</>
	);
}

function ParkingLocation(props: any) {
	const {t} = useTranslation();
	const [bbox, setBbox] = useState([]);
	const {location, markerClicked} = props;
	const parkingPosition: LatLngExpression = [parseFloat(location.y), parseFloat(location.x)];
	// const [position, setPosition] = useState(parkingPosition);
	// const map = useMap();
	// const radius = map.getScaleZoom()
	// const circle = L.circle(e.latlng, radius);
	// circle.addTo(map);
	// map.flyTo(parkingPosition, map.getZoom());
	// const mapEvents = useMapEvents({
	// 	click: () => {
	// 		mapEvents.locate()
	// 	},
	// 	locationfound: (location) => {
	// 		console.log('location found:', location)
	// 	},
	// })
	// return null;
	// useEffect(() => {
	// 	map.locate().on("locationfound", function (e) {
	// 		setPosition(e.latlng);
	// 		map.flyTo(e.latlng, map.getZoom());
	// 		const radius = e.accuracy;
	// 		const circle = L.circle(e.latlng, radius);
	// 		circle.addTo(map);
	// 		setBbox(e.bounds.toBBoxString().split(","));
	// 	});
	// }, [map]);
	let parkingColor = onlineCapacityToColor(location.onlineCapacity, location.capacity);
	let click = false;
	return (
		<>
			<Marker
				key={'parking_marker'}
				position={parkingPosition}
				draggable={false}
				eventHandlers={{
					//@ts-ignore
					click: event => {
						click = true;
						markerClicked(event, 'parking', location);
					}
				}}
				// ref={markerRef}
				icon={divLeafletIcon(colors[parkingColor]['color'], click)}
			>
				<Circle
					center={parkingPosition}
					// radius={getRadius(zoom)}
					radius={100}
					pathOptions={{color: colors[parkingColor]['color'], fillColor: colors[parkingColor]['color']}}
					stroke={false}
				/>
				{/*<Popup>*/}
				{/*	<div>*/}
				{/*		<Typography*/}
				{/*			gutterBottom*/}
				{/*			variant="h5"*/}
				{/*			component="div"*/}
				{/*			className="font-bold text-center"*/}
				{/*			sx={{*/}
				{/*				color: () => colors[parkingColor]['color'],*/}
				{/*				fontSize: (theme) => theme.typography.fontSize*/}
				{/*			}}*/}
				{/*		>*/}
				{/*			{location.name}*/}
				{/*		</Typography>*/}
				{/*		<div className="flex flex-row text-center justify-between items-center">*/}
				{/*			<div className="flex flex-row justify-between items-center">*/}
				{/*				{*/}
				{/*					location.onlineCapacity > 0 ? (*/}
				{/*						<>*/}
				{/*							<Typography sx={{*/}
				{/*								color: (theme) => theme.palette.mode === 'light' ? 'grey.500' : 'grey.300',*/}
				{/*								fontSize: (theme) => theme.typography.fontSize*/}
				{/*							}}>*/}
				{/*								{t('parking.empty_capacity')}:*/}
				{/*							</Typography>*/}
				{/*							<Typography sx={{*/}
				{/*								color: (theme) => {*/}
				{/*									// @ts-ignore*/}
				{/*									return location.onlineCapacity > 10 ? 'gray.600' : theme.palette.warning[600];*/}
				{/*								},*/}
				{/*								fontSize: (theme) => theme.typography.fontSize*/}
				{/*							}}>*/}
				{/*								{location.onlineCapacity}*/}
				{/*							</Typography>*/}
				{/*						</>*/}
				{/*					) : (*/}
				{/*						<Typography sx={{*/}
				{/*							color: () => colors[parkingColor]['color'],*/}
				{/*							fontSize: (theme) => theme.typography.fontSize*/}
				{/*						}}>*/}
				{/*							{t('parking.empty_capacity_text')}*/}
				{/*						</Typography>*/}
				{/*					)*/}
				{/*				}*/}
				{/*			</div>*/}
				{/*			<div className="flex flex-row justify-between items-center">*/}
				{/*				<Typography sx={{*/}
				{/*					color: (theme) => theme.palette.mode === 'light' ? 'grey.500' : 'grey.300',*/}
				{/*					fontSize: (theme) => theme.typography.fontSize*/}
				{/*				}}>*/}
				{/*					{t('parking.total_capacity')}:*/}
				{/*				</Typography>*/}
				{/*				<Typography*/}
				{/*					sx={{*/}
				{/*						color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.200',*/}
				{/*						fontSize: (theme) => theme.typography.fontSize*/}
				{/*					}}>*/}
				{/*					{location.capacity}*/}
				{/*				</Typography>*/}
				{/*			</div>*/}
				{/*		</div>*/}
				{/*		<div className="flex flex-row justify-start items-center">*/}
				{/*			<Typography sx={{*/}
				{/*				color: (theme) => theme.palette.mode === 'light' ? 'grey.500' : 'grey.300',*/}
				{/*				fontSize: (theme) => theme.typography.fontSize*/}
				{/*			}}>*/}
				{/*				{t('parking.address')}:*/}
				{/*			</Typography>*/}
				{/*			<Typography*/}
				{/*				className="text-center"*/}
				{/*				sx={{*/}
				{/*					color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.200',*/}
				{/*					fontSize: (theme) => theme.typography.fontSize*/}
				{/*				}}>*/}
				{/*				{location.address}*/}
				{/*			</Typography>*/}
				{/*		</div>*/}
				{/*	</div>*/}
				{/*</Popup>*/}
			</Marker>
		</>
	);
}

function LiveLocation(props: any) {
	const {t} = useTranslation();
	const {markerClicked} = props;
	const {setLatLng} = useMapContext();
	const {liveLocation, setLiveLocation} = useProjectContext();
	const [markerLocation, setMarkerLocation] = useState(liveLocation);
	// const [bbox, setBbox] = useState([]);
	// const [livePosition, setLivePosition] = useState<any>([]);
	// const [liveFound, setLiveFound] = useState(false);
	// const [position, setPosition] = useState(parkingPosition);
	const map = useMap();
	const markerRef = useRef();
	
	const markerDragEnd = (event: TLatLng) => {
		// @ts-ignore
		setMarkerLocation(event);
		setLiveLocation(event);
		setLatLng(event);
	};
	
	return (
		<div className="w-full h-full">
			{
				markerLocation ? (
					<Marker
						key={'live_marker'}
						position={markerLocation}
						draggable={true}
						eventHandlers={{
							click: event => markerClicked(event, 'live', liveLocation),
							//@ts-ignore
							dragend: () => markerDragEnd<TLatLng>(markerRef.current.getLatLng())
						}}
						//@ts-ignore
						ref={markerRef}
						icon={MarkerLiveIcon}
					>
						<Circle
							center={markerLocation}
							// radius={getRadius(zoom)}
							radius={100}
							pathOptions={{color: '#539fe5', fillColor: '#539fe5'}}
							stroke={false}
						/>
						{/*<Popup>*/}
						{/*	<Typography*/}
						{/*		gutterBottom*/}
						{/*		variant="h5"*/}
						{/*		component="div"*/}
						{/*		className="font-bold text-center"*/}
						{/*		sx={{*/}
						{/*			color: (theme) => {*/}
						{/*				// @ts-ignore*/}
						{/*				return theme.palette.success[600];*/}
						{/*			},*/}
						{/*			fontSize: (theme) => theme.typography.fontSize*/}
						{/*		}}*/}
						{/*	>*/}
						{/*		{t('parking.live_location')}*/}
						{/*	</Typography>*/}
						{/*</Popup>*/}
					</Marker>
				) : null
			}
			{/*<Container>*/}
			{/*	<Button size="small" color="primary" onClick={DisplayLocation}>*/}
			{/*		{t('parking.display_location')}*/}
			{/*	</Button>*/}
			{/*</Container>*/}
		</div>
	);
}

function LocationMarker() {
	const [position, setPosition] = useState(null);
	const map2 = useMap();
	map2.locate();
	
	const map = useMapEvents({
		click() {
			map.locate();
		},
		locationfound(e) {
			// @ts-ignore
			setPosition(e.latlng);
			map.flyTo(e.latlng, map.getZoom());
		}
	});
	
	return position === null ? null : (
		<Marker position={position}>
			<Popup>You are here</Popup>
		</Marker>
	);
}

function getRadius(currentZoom: number) {
	var radius;
	if (currentZoom === 7) {
		radius = 300;
	} else if (currentZoom === 8) {
		radius = 280;
	} else if (currentZoom === 9) {
		radius = 240;
	} else if (currentZoom === 10) {
		radius = 220;
	} else if (currentZoom === 11) {
		radius = 200;
	} else if (currentZoom === 12) {
		radius = 180;
	} else if (currentZoom === 13) {
		radius = 160;
	} else if (currentZoom === 14) {
		radius = 140;
	} else if (currentZoom === 15) {
		radius = 120;
	} else if (currentZoom === 16) {
		radius = 100;
	} else if (currentZoom === 17) {
		radius = 80;
	} else if (currentZoom === 18) {
		radius = 60;
	}
	return radius;
}

export const layersMap = [
	{
		name: 'osm_hot',
		attribution: 'Rezvan',
		url: 'http://tile-{s}.openstreetmap.fr/hot/{z}/{x}/{y}.png'
	},
	{
		name: 'osm',
		attribution: 'Rezvan',
		url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
	},
	{
		name: 'arc_gis',
		attribution: 'Rezvan',
		url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}'
	},
	// {
	// 	name: 'Black&White',
	// 	attribution: 'Rezvan',
	// 	url: 'https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png'
	// },
	// {
	// 	name: 'Osm2',
	// 	attribution: 'Rezvan',
	// 	url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png'
	// },
	// {
	// 	name: 'Stadia1',
	// 	attribution: 'Rezvan',
	// 	url: 'http://tiles.mapc.org/basemap/{z}/{x}/{y}.png'
	// },
	// {
	// 	name: 'Stadia2',
	// 	attribution: 'Rezvan',
	// 	url: 'http://tiles.mapc.org/trailmap-onroad/{z}/{x}/{y}.png'
	// },
	// {
	// 	name: 'Stadia',
	// 	attribution: 'Rezvan',
	// 	url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png'
	// },
	// {
	// 	name: 'Carto',
	// 	attribution: 'Rezvan',
	// 	url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_nolabels/{z}/{x}/{y}.png'
	// }
	{
		name: 'dark',
		attribution: 'Rezvan',
		url: 'https://{s}.basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}.png'
	}
	// {
	// 	name: 'OMap',
	// 	attribution: 'Rezvan',
	// 	url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png'
	// }
];
var getSlippyTileLayerPoints = function (lat_deg: number, lng_deg: number, zoom: number) {
	var x = (Math.floor((lng_deg + 180) / 360 * Math.pow(2, zoom)));
	var y = (Math.floor((1 - Math.log(Math.tan(lat_deg * Math.PI / 180) + 1 / Math.cos(lat_deg * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, zoom)));
	
	var layerPoint = {
		x: x,
		y: y
	};
	
	return layerPoint;
};

const onlineCapacityToColor = (onlineCapacity: number, totalCapacity: number) => {
	let colorCount = 0;
	let vacancyPercentageL = 10;
	let freePercent = (onlineCapacity * 100 / totalCapacity);
	switch (true) {
		case (freePercent === 0):
			colorCount = 0;
			break;
		// case (onlineCount < 10):
		// 	colorCount = 10;
		// 	break;
		// case (onlineCount < 20):
		// 	colorCount = 20;
		// 	break;
		case (freePercent < vacancyPercentageL):
			colorCount = 20;
			break;
		// case (onlineCount < 200):
		// 	colorCount = 200;
		// 	break;
		// case (onlineCount < 500):
		// 	colorCount = 500;
		// 	break;
		case (freePercent > vacancyPercentageL):
			colorCount = 500;
			break;
		default:
	}
	return colorCount;
};
const Transition = React.forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement<any, any>;
	},
	ref: React.Ref<unknown>
) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const MapComponent = () => {
	const theme = useTheme();
	const {t} = useTranslation();
	let mapRef = createRef();
	const {liveLocation, setLiveLocation, liveFound, setLiveFound} = useProjectContext();
	const {
		refetch,
		map,
		setMap,
		zoom,
		imamRezaShrine,
		parkingLot,
		setParkingLot,
		parkingLots,
		setParkingLots,
		parkingLotsFilter,
		setParkingLotsFilter,
		parkingFilterKey,
		setParkingFilterKey,
		showParkingLots,
		setShowParkingLots,
		latLng,
		setLatLng,
		openSnack,
		setOpenSnack,
		counter,
		setCounter
	} = useMapContext();
	const [start, setStart] = useState<TLatLng>({lat: 36.2884, lng: 59.6157});
	const [end, setEnd] = useState<TLatLng>({lat: 36.29512936, lng: 59.60121095});
	const [routingMachine, setRoutingMachine] = useState(null);
	const [mapLoaded, setMapLoaded] = useState<boolean>(false);
	const [dialogOpen, setDialogOpen] = useState<boolean>(false);
	const [dialogInfo, setDialogInfo] = useState<TParking>();
	const [dialogComponent, setDialogComponent] = useState<string>('parking');
	const [dialogColor, setDialogColor] = useState<number>(500);
	// Analytics-----------------------------------
	// const {track} = useAnalytics();
	// -----------------------------------
	const markerClicked = (_marker: L.LeafletMouseEvent, component: 'parking', info: TParking) => {
		setDialogOpen(true);
		setDialogInfo(info);
		setDialogComponent(component);
		if (component === 'parking') {
			/*track('parkingClick', {
				name: info.name
			});*/
			let parkingColor = onlineCapacityToColor(parseFloat(info.onlineCapacity as string), parseFloat(info.capacity as string));
			setDialogColor(parkingColor);
			if (setParkingLot) {
				setParkingLot(info);
				localStorage.setItem('parkingLot', JSON.stringify(info));
			}
		} else {
			setDialogColor(500);
		}
	};
	const [snackMessageOpen, setSnackMessageOpen] = useState<boolean>(liveFound !== 1);
	//TODO check this
	// if (latLng) {
	// 	// @ts-ignore
	// 	map?.flyTo(latLng, map.getZoom());
	// }
	
	useEffect(() => {
		// if (setParkingFilterKey) {
		setTimeout(() => {
			setShowParkingLots(true);
		}, 1000);
		// }
	}, [mapLoaded]);
	
	useEffect(() => {
		setOpenSnack(!liveFound);
	}, [liveFound]);
	
	useEffect(() => {
		setDialogInfo(() => parkingLot);
		setTimeout(() => {
			if (parkingLot) {
				// let parkingColor = onlineCapacityToColor(parseFloat(parkingLot.onlineCapacity as string), parseFloat(parkingLot.capacity as string));
				// setDialogColor(parkingColor);
				setDialogOpen(true);
			}
		}, 500);
	}, []);
	// // @ts-ignore
	// map?.control?.scale({
	// 	imperial: false,
	// })
	// 	.addTo(map);
	// const mapRef = useRef();
	// const mapRef = createRef();
	// @ts-ignore
	// map.flyTo(position, map.getZoom());
	// const displayMap = useMemo(
	// 	() => (
	// 		<MapContainer
	// 			// @ts-ignore
	// 			ref={setMap}
	// 			center={position}
	// 			zoom={zoom}
	// 			scrollWheelZoom={false}
	// 			className="map"
	// 		>
	// 			<TileLayer
	// 				attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
	// 				url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
	// 			/>
	// 			<Pane name="custom" style={{zIndex: 100}}>
	// 				<Circle center={position} radius={200} pathOptions={{color: '#8da8ff'}}/>
	// 			</Pane>
	// 			<LocationMarker/>
	// 			<Marker
	// 				position={position}
	// 				draggable={false}
	// 				// eventHandlers={eventHandlers}
	// 				// ref={markerRef}
	// 				icon={DefaultIcon}
	// 			>
	// 				<Popup>
	// 					{
	// 						parkingLocation.address
	// 					}
	// 				</Popup>
	// 			</Marker>
	// 		</MapContainer>
	// 	),
	// 	[]
	// );
	const ShowBoundsArea = () => {
		// let parkingBounds: TParking[] = [];
		let markerBounds = latLngBounds([]);
		markerBounds.extend([parseFloat(imamRezaShrine!.y), parseFloat(imamRezaShrine!.x)]);
		if (liveLocation) {
			markerBounds.extend([liveLocation?.lat, liveLocation?.lng]);
		}
		if (parkingLot) {
			markerBounds.extend([parseFloat(parkingLot!.y), parseFloat(parkingLot!.x)]);
		}
		if (liveLocation || parkingLot) {
			markerBounds?.isValid() && map?.fitBounds(markerBounds);
		}
		// parkingLots?.map((parking) => {
		// 	// parkingBounds.push([parseFloat(parking?.y as string), parseFloat(parking?.x as string)]);
		// 	if (parking.x && parking.y) {
		// 		markerBounds.extend([parseFloat(parking?.y as string), parseFloat(parking?.x as string)]);
		// 	}
		// });
		// markerBounds.extend(...[parkingBounds]);
		// @ts-ignore
		
		// Object.keys(locations).map((location)=>{
		// 	bounds.push()
		// })
	};
	const showLiveLocation = () => {
		setLiveFound(LiveFoundObject.Locating);
		// let successHandler = function (position: { coords: { latitude: any; longitude: any; }; }) {
		// 	alert(position.coords.latitude);
		// 	alert(position.coords.longitude);
		// 	// @ts-ignore
		// 	setLiveLocation([position.coords.latitude, position.coords.longitude]);
		// };
		//
		// let errorHandler = function (errorObj: any) {
		// 	alert(errorObj.code + ': ' + errorObj.message);
		// 	alert('something wrong take this lat ' + 26.0546106);
		// 	alert('something wrong take this lng ' + -98.3939791);
		//
		// };
		// if (navigator.geolocation) {
		// 	navigator.geolocation.getCurrentPosition(
		// 		successHandler, errorHandler,
		// 		{enableHighAccuracy: true, maximumAge: 10000}
		// 	);
		// } else {
		// 	console.error('Geolocation is not supported by this browser.');
		// }
		//
		// return new Promise((resolve, reject) => {
		try {
			map?.locate({
				setView: false,
				enableHighAccuracy: true
			})?.on('locationfound', function (e: {
				latlng: React.SetStateAction<TLatLng | undefined>;
			}) {
				// console.log(e);
				// @ts-ignore
				setLiveLocation(e.latlng);
				setLiveFound(LiveFoundObject.Found);
				// @ts-ignore
				setLatLng(e.latlng);
				setTimeout(() => {
					// @ts-ignore
					map?.flyTo(e.latlng, map.getZoom());
				}, 500);
				// const radius = e.accuracy * 10;
				// const circle = L.circle(e.latlng, radius);
				// const circle = L.circleMarker(e.latlng, {
				// 	radius: radius,
				// 	color: '#ffb4ab',
				// 	fillColor: '#de3730'
				// });
				// circle.addTo(map);
				// setBbox(e.bounds.toBBoxString().split(','));
				// @ts-ignore
				map?.stopLocate();
				// resolve(e.latlng);
				// console.log(e.latlng);
			}).on('locationerror', function (e: any) {
				setLiveFound(LiveFoundObject.NotFound);
				// reject(e);
				console.log(e);
			});
		} catch (err) {
			setLiveFound(LiveFoundObject.NotFound);
			console.log(err);
		}
		// });
	};
	const flyToShrine = () => {
		try {
			map?.flyTo({
				lat: parseFloat(imamRezaShrine?.y as string),
				lng: parseFloat(imamRezaShrine?.x as string)
			}, map.getZoom());
		} catch (err) {
		}
	};
	const fetchLiveLocation = () => {
		if (liveFound <= 0) {
			setLiveFound(LiveFoundObject.Locating);
			if (navigator.geolocation) {
				// get the current users location
				navigator.geolocation.getCurrentPosition(
					(position) => {
						// save the geolocation coordinates in two variables
						const {latitude, longitude} = position.coords;
						// update the value of userlocation variable
						map?.flyTo({lat: latitude, lng: longitude}, map.getZoom());
						setLiveFound(LiveFoundObject.Found);
						setLiveLocation({lat: latitude, lng: longitude});
					},
					// if there was an error getting the users location
					(error) => {
						console.error('Error getting user location:', error);
					}
				);
			}
		}
	};
	
	function ParkingLotsOnMap(props: {
		parkingLotsFilter: any;
		showControl: any;
	}) {
		const {parkingLotsFilter, showControl} = props;
		const {t} = useTranslation();
		const map = useMap();
		// const iconMarkup = (color: string) => {
		// 	return renderToStaticMarkup(<FlagLogo fill={color}/>);
		// };
		// const customMarkerIcon = (color: string) => {
		// 	return divIcon({
		// 		html: iconMarkup(color)
		// 	});
		// };
		
		
		// useEffect(() => {
		// 	ShowBoundsArea(
		// 		{
		// 			parkingLots: parkingLot ? [parkingLot] : [],
		// 			live: liveLocation,
		// 			shrine: imamRezaShrine
		// 		},
		// 		true
		// 	);
		// }, [parkingLotsFilter]);
		
		
		//TODO Enable Show Bounds
		// ShowBoundsArea({parkingLots: parkingLotsFilter});
		
		// useEffect(() => {
		// 	ShowBoundsArea(
		// 		{
		// 			parkingLots: parkingLot ? [parkingLot] : [],
		// 			live: liveLocation,
		// 			shrine: imamRezaShrine
		// 		},
		// 		true
		// 	);
		// }, [parkingLotsFilter]);
		//
		
		
		return (
			<div>
				{
					// <Control prepend={false} position="bottomright">
					// 	<div className="parkingLotCapacity flex flex-col bg-[#FFFFFF90] p-1">
					// 		<Typography sx={{
					// 			color: 'gray.600',
					// 			fontSize: (theme) => theme.typography.fontSize - 3
					// 		}}>
					// 			{t('parking.online_capacity')}
					// 		</Typography>
					// 		{
					// 			Object.keys(colors).reverse().map((color, index) => {
					// 				return (
					// 					<div className="flex flex-row-reverse">
					// 						<i className={`${colors[color]['class']}`}></i>
					// 						<span>
					// 						{color}
					// 							{colors[color + 1] ? `&ndash; ${colors[color + 1]}` : ''}
					// 					</span>
					// 					</div>
					// 				);
					// 			})
					// 		}
					// 	</div>
					// </Control>
				}
				<div className="w-full h-[calc(100vh-120px)]">
					{
						parkingLotsFilter.map((parking: TParking, index: number) => {
							let onlineCapacity = parseFloat(parking.onlineCapacity);
							let totalCapacity = parseFloat(parking.capacity);
							
							if (parseFloat(parking?.y) && parseFloat(parking?.x)) {
								let click = false;
								return (
									<Marker
										key={`parking_marker_${index}`}
										position={[parseFloat(parking?.y), parseFloat(parking?.x)]}
										draggable={false}
										eventHandlers={{
											click: event => {
												click = true;
												markerClicked(event, 'parking', parking);
											}
										}}
										// icon={customMarkerIcon(colors[onlineCapacityToColor(parkingCapacity)]['color'])}
										// icon={divIcon(colors[color]['color'])}
										icon={divLeafletIcon(colors[onlineCapacityToColor(onlineCapacity, totalCapacity)]['color'], click)}
										// icon={MarkerParkingLotsMultiIcon(parkingColor)}
										//@ts-ignore
									>
										{/*<Popup>*/}
										{/*	<div>*/}
										{/*		<Typography*/}
										{/*			gutterBottom*/}
										{/*			variant="h5"*/}
										{/*			component="div"*/}
										{/*			className="font-bold text-center"*/}
										{/*			sx={{*/}
										{/*				color: (theme) => {*/}
										{/*					// @ts-ignore*/}
										{/*					return parseFloat(parking.onlineCapacity) > 10 ? theme.palette.success[600] : parseFloat(parking.onlineCapacity) > 0 ? theme.palette.warning[600] : theme.palette.error[600];*/}
										{/*				},*/}
										{/*				fontSize: (theme) => theme.typography.fontSize*/}
										{/*			}}*/}
										{/*		>*/}
										{/*			{parking.name}*/}
										{/*		</Typography>*/}
										{/*		<div className="flex flex-row text-center justify-between items-center">*/}
										{/*			<div className="flex flex-row justify-between items-center">*/}
										{/*				{*/}
										{/*					parseFloat(parking.onlineCapacity) > 0 ? (*/}
										{/*						<>*/}
										{/*							<Typography sx={{*/}
										{/*								color: (theme) => {*/}
										{/*									// @ts-ignore*/}
										{/*									return parseFloat(parking.onlineCapacity) > 10 ? 'gray.600' : theme.palette.warning[600];*/}
										{/*								},*/}
										{/*								fontSize: (theme) => theme.typography.fontSize*/}
										{/*							}}>*/}
										{/*								{t('parking.empty_capacity')}:*/}
										{/*							</Typography>*/}
										{/*							<Typography sx={{*/}
										{/*								color: (theme) => {*/}
										{/*									// @ts-ignore*/}
										{/*									return parseFloat(parking.onlineCapacity) > 10 ? 'gray.600' : theme.palette.warning[600];*/}
										{/*								},*/}
										{/*								fontSize: (theme) => theme.typography.fontSize*/}
										{/*							}}>*/}
										{/*								{parseFloat(parking.onlineCapacity)}*/}
										{/*							</Typography>*/}
										{/*						</>*/}
										{/*					) : (*/}
										{/*						<Typography sx={{*/}
										{/*							color: (theme) => {*/}
										{/*								// @ts-ignore*/}
										{/*								return theme.palette.mode === 'light' ? theme.palette.error[600] : theme.palette.error[600];*/}
										{/*							},*/}
										{/*							fontSize: (theme) => theme.typography.fontSize*/}
										{/*						}}>*/}
										{/*							{t('parking.empty_capacity_text')}*/}
										{/*						</Typography>*/}
										{/*					)*/}
										{/*				}*/}
										{/*			</div>*/}
										{/*			<div className="flex flex-row justify-between items-center">*/}
										{/*				<Typography sx={{*/}
										{/*					color: (theme) => theme.palette.mode === 'light' ? 'grey.500' : 'grey.300',*/}
										{/*					fontSize: (theme) => theme.typography.fontSize*/}
										{/*				}}>*/}
										{/*					{t('parking.total_capacity')}:*/}
										{/*				</Typography>*/}
										{/*				<Typography*/}
										{/*					sx={{*/}
										{/*						color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.200',*/}
										{/*						fontSize: (theme) => theme.typography.fontSize*/}
										{/*					}}>*/}
										{/*					{parking.capacity}*/}
										{/*				</Typography>*/}
										{/*			</div>*/}
										{/*		</div>*/}
										{/*		<div className="flex flex-row justify-start items-center">*/}
										{/*			<Typography sx={{*/}
										{/*				color: (theme) => theme.palette.mode === 'light' ? 'grey.500' : 'grey.300',*/}
										{/*				fontSize: (theme) => theme.typography.fontSize*/}
										{/*			}}>*/}
										{/*				{t('parking.address')}:*/}
										{/*			</Typography>*/}
										{/*			<Typography*/}
										{/*				className="text-center"*/}
										{/*				sx={{*/}
										{/*					color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.200',*/}
										{/*					fontSize: (theme) => theme.typography.fontSize*/}
										{/*				}}>*/}
										{/*				{parking.address}*/}
										{/*			</Typography>*/}
										{/*		</div>*/}
										{/*	</div>*/}
										{/*</Popup>*/}
									</Marker>
								);
							}
						})
					}
					{/*<Container>*/}
					{/*	<Button size="small" color="primary" onClick={DisplayLocation}>*/}
					{/*		{t('parking.display_location')}*/}
					{/*	</Button>*/}
					{/*</Container>*/}
				</div>
			</div>
		);
	}
	
	// ----------------------------------------------------------------------------------
// 	// Create the routing-machine instance:
// 	const RoutingMachineRef = useRef(null);
// 	useEffect(() => {
// 		if (!map) return;
// 		if (map) {
// 			// @ts-ignore
// 			RoutingMachineRef.current = L.Routing.control({
// 				position: 'topleft',
// 				// @ts-ignore
// 				lineOptions: {
// 					styles: [
// 						{
// 							color: '#757de8'
// 						}
// 					]
// 				},
// 				// @ts-ignore
// 				waypoints: [start, end]
// 			});
// 			setRoutingMachine(RoutingMachineRef.current);
// 		}
// 	}, [map]);
//
// // Set waypoints when start and end points are updated:
// 	useEffect(() => {
// 		if (routingMachine) {
// 			// @ts-ignore
// 			routingMachine.addTo(map);
// 			// @ts-ignore
// 			routingMachine.setWaypoints([start, end]);
// 		}
// 	}, [routingMachine, start, end]);
	// ----------------------------------------------------------------------------------
	
	// useEffect(() => {
	// 	console.log(latLng);
	// 	// @ts-ignore
	// 	setTimeout(() => {
	// 		map?.flyTo(latLng, map.getZoom());
	// 		}, 1000);
	// }, [latLng]);
	const layerControlBase = (props: { name: string; }) => {
		const {name} = props;
		return (
			<Typography sx={{
				color: 'gray.600',
				fontSize: (theme) => theme.typography.fontSize - 3,
				fontWeight: 'bold'
			}}>
				{t(`parking.layers.${name}`)}
			</Typography>
		);
	};
	// const displayMap = useMemo(
	// 	() => (
	//
	// 	), []
	// );
	
	const handleClickOpen = () => {
		setDialogOpen(true);
	};
	
	const handleClose = () => {
		setDialogOpen(false);
	};
	const handleSnackClick = () => {
		setSnackMessageOpen(true);
	};
	
	const handleSnackClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
		if (reason === 'clickaway') {
			return;
		}
		setSnackMessageOpen(false);
	};
	
	function TransitionUp(props: TransitionProps) {
		// @ts-ignore
		return <Slide {...props} direction="up"/>;
	}
	
	const snackLocationNotFound = () => {
		if (liveFound === 1) {
			return false;
		} else {
			return snackMessageOpen;
		}
	};
	const ZoomControl = () => {
		const zoomIn = (e: { preventDefault: () => void; }) => {
			e.preventDefault();
			map?.setZoom(map?.getZoom() + 1);
		};
		const zoomOut = (e: { preventDefault: () => void; }) => {
			e.preventDefault();
			map?.setZoom(map?.getZoom() - 1);
		};
		return (
			<div className="flex flex-col items-center bg-[#ffffffe6] p-1 text-center text-lg text-black rounded font-bold">
				<Typography
					component="div"
					className="w-7 h-7 text-black border-b border-gray-300"
					title="Zoom in"
					role="button"
					aria-label="Zoom in"
					onClick={zoomIn}
					sx={{
						color: () => colors[dialogColor]['color'],
						fontSize: (theme) => theme.typography.fontSize + 5
					}}
				>
					+
				</Typography>
				<Typography
					component="div"
					className="w-7 h-7 text-black pt-1"
					title="Zoom out"
					role="button"
					aria-label="Zoom out"
					onClick={zoomOut}
					sx={{
						color: () => colors[dialogColor]['color'],
						fontSize: (theme) => theme.typography.fontSize + 5
					}}
				>
					−
				</Typography>
			</div>
		);
	};
	
	function ModalDialog() {
		return (
			<TrapFocus open={dialogOpen} disableRestoreFocus disableAutoFocus>
				<ClickAwayListener
					// mouseEvent="onMouseDown"
					touchEvent="onTouchStart"
					onClickAway={() => {
						// setDialogOpen(false);
					}}
				>
					<Fade
						appear={false}
						in={dialogOpen}
					>
						<Paper
							role="dialog"
							aria-modal="false"
							aria-label="Parking info"
							square
							variant="outlined"
							tabIndex={-1}
							elevation={0}
							className="min-h-max w-11/12 fixed bottom-12 left-0 right-0 mx-auto p-2 justify-center items-center border-0 rounded"
							sx={{
								bgcolor: (theme) => theme.palette.mode === 'light' ? 'white' : 'grey.800',
								zIndex: 10000
							}}
						>
							
							<>
								<div className="flex cursor-pointer absolute top-2 right-2" onClick={() => setDialogOpen(false)}>
									<CloseIcon/>
								</div>
								{/*<Stack*/}
								{/*	gap={2}*/}
								{/*	direction={{*/}
								{/*		xs: 'row-reverse',*/}
								{/*		sm: 'row'*/}
								{/*	}}*/}
								{/*	sx={{*/}
								{/*		flexShrink: 0,*/}
								{/*		alignSelf: {xs: 'flex-end', sm: 'center'}*/}
								{/*	}}*/}
								{/*>*/}
								
								<div>
									{
										dialogComponent !== 'parking' ? (
											<div>
												<Typography
													gutterBottom
													variant="h5"
													component="div"
													className="font-bold text-center my-3"
													sx={{
														color: () => dialogComponent === 'shrine' ? '#ffa726' : '#00629f',
														fontSize: (theme) => theme.typography.fontSize + 3
													}}
												>
													{
														t(`parking.${dialogComponent}`)
													}
												</Typography>
												{
													liveLocation && (
														<div className="mt-2 mb-2 flex justify-center">
															{
																dialogComponent === 'shrine' && (
																	<Link
																		to={`/parking/route/live_shrine/${[liveLocation?.lat, liveLocation?.lng]}/${[parseFloat(imamRezaShrine?.y as string), parseFloat(imamRezaShrine?.x as string)]}`}>
																		{/*<Button*/}
																		{/*	sx={{*/}
																		{/*		background: (theme) => 'linear-gradient(45deg, #0051de 50%, #638aff 100%)',*/}
																		{/*	}}*/}
																		{/*	size="small"*/}
																		{/*	color="primary"*/}
																		{/*	variant="contained"*/}
																		{/*>*/}
																		{/*	{t('parking.dir_to_parking')}*/}
																		{/*</Button>*/}
																		<Button
																			size="small"
																			className="border-0 bg-gradient-to-r from-[#0051de] to-[#638aff] text-white px-5 py-1 rounded-md"
																		>
																			{t('parking.dir_to_shrine')}
																		</Button>
																	</Link>
																)
															}
															{
																dialogComponent === 'live' && (
																	<Link
																		to={`/parking/route/live_shrine/${[liveLocation?.lat, liveLocation?.lng]}/${[parseFloat(imamRezaShrine?.y as string), parseFloat(imamRezaShrine?.x as string)]}`}>
																		{/*<Button*/}
																		{/*	sx={{*/}
																		{/*		background: (theme) => 'linear-gradient(45deg, #0051de 50%, #638aff 100%)',*/}
																		{/*	}}*/}
																		{/*	size="small"*/}
																		{/*	color="primary"*/}
																		{/*	variant="contained"*/}
																		{/*>*/}
																		{/*	{t('parking.dir_to_parking')}*/}
																		{/*</Button>*/}
																		<Button
																			size="small"
																			className="border-0 bg-gradient-to-r from-[#0051de] to-[#638aff] text-white px-5 py-1 rounded-md"
																		>
																			{t('parking.dir_to_shrine')}
																		</Button>
																	</Link>
																)
															}
														</div>
													)
												}
											</div>
										) : (
											<div>
												<Typography
													gutterBottom
													variant="h5"
													component="div"
													className="font-bold text-center my-3"
													sx={{
														color: () => colors[dialogColor]['color'],
														fontSize: (theme) => theme.typography.fontSize + 3
													}}
												>
													{
														dialogInfo?.name
													}
												</Typography>
												<div className="flex flex-row text-center justify-between items-center">
													<div className="flex flex-row justify-between items-center">
														{
															parseFloat(dialogInfo?.onlineCapacity as string) > 0 ? (
																<>
																	<Typography sx={{
																		color: (theme) => {
																			// @ts-ignore
																			return parseFloat(dialogInfo?.onlineCapacity) > 10 ? 'gray.600' : theme.palette.warning[600];
																		},
																		fontSize: (theme) => theme.typography.fontSize + 3
																	}}>
																		{t('parking.empty_capacity')}:
																	</Typography>
																	<Typography sx={{
																		color: (theme) => {
																			// @ts-ignore
																			return parseFloat(dialogInfo?.onlineCapacity) > 10 ? 'gray.600' : theme.palette.warning[600];
																		},
																		fontSize: (theme) => theme.typography.fontSize + 3
																	}}>
																		{
																			dialogInfo?.onlineCapacity
																		}
																	</Typography>
																</>
															) : (
																<Typography sx={{
																	color: (theme) => {
																		// @ts-ignore
																		return theme.palette.mode === 'light' ? theme.palette.error[600] : theme.palette.error[600];
																	},
																	fontSize: (theme) => theme.typography.fontSize + 3
																}}>
																	{t('parking.empty_capacity_text')}
																</Typography>
															)
														}
													</div>
													<div className="flex flex-row justify-between items-center">
														<Typography sx={{
															color: (theme) => theme.palette.mode === 'light' ? 'grey.500' : 'grey.300',
															fontSize: (theme) => theme.typography.fontSize + 3
														}}>
															{t('parking.total_capacity')}:
														</Typography>
														<Typography
															sx={{
																color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.200',
																fontSize: (theme) => theme.typography.fontSize + 3
															}}>
															{
																dialogInfo?.capacity
															}
														</Typography>
													</div>
												</div>
												<div className="flex flex-row justify-start items-center">
													<Typography sx={{
														color: (theme) => theme.palette.mode === 'light' ? 'grey.500' : 'grey.300',
														fontSize: (theme) => theme.typography.fontSize + 3
													}}>
														{t('parking.address')}:
													</Typography>
													<Typography
														className="text-center"
														sx={{
															color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.200',
															fontSize: (theme) => theme.typography.fontSize + 3
														}}>
														{
															dialogInfo?.address
														}
													</Typography>
												</div>
												<div className="mt-2 mb-2">
													<div className="flex flex-row justify-center gap-2">
														{
															liveLocation && (
																<Link
																	to={`/parking/route/live_parking/${[liveLocation?.lat, liveLocation?.lng]}/${[parseFloat(dialogInfo?.y as string), parseFloat(dialogInfo?.x as string)]}`}>
																	{/*<Button*/}
																	{/*	sx={{*/}
																	{/*		background: (theme) => 'linear-gradient(45deg, #0051de 50%, #638aff 100%)',*/}
																	{/*	}}*/}
																	{/*	size="small"*/}
																	{/*	color="primary"*/}
																	{/*	variant="contained"*/}
																	{/*>*/}
																	{/*	{t('parking.dir_to_parking')}*/}
																	{/*</Button>*/}
																	<Button
																		size="small"
																		className="border-0 bg-gradient-to-r from-[#0051de] to-[#638aff] text-white px-5 py-1 rounded-md"
																	>
																		{t('parking.dir_to_parking')}
																	</Button>
																</Link>
															)
														}
														<Link
															to={`/parking/route/parking_shrine/${[parseFloat(dialogInfo?.y as string), parseFloat(dialogInfo?.x as string)]}/${[parseFloat(imamRezaShrine?.y as string), parseFloat(imamRezaShrine?.x as string)]}`}>
															{/*<Button*/}
															{/*	sx={{*/}
															{/*		background: (theme) => 'linear-gradient(45deg, #0051de 50%, #638aff 100%)',*/}
															{/*	}}*/}
															{/*	size="small"*/}
															{/*	color="primary"*/}
															{/*	variant="contained"*/}
															{/*>*/}
															{/*	{t('parking.dir_to_parking')}*/}
															{/*</Button>*/}
															<Button
																size="small"
																className="border-0 bg-gradient-to-r from-[#0051de] to-[#638aff] text-white px-5 py-1 rounded-md"
															>
																{t('parking.dir_to_shrine')}
															</Button>
														</Link>
													</div>
												</div>
											</div>
										)
									}
								</div>
								{/*</Stack>*/}
							</>
						
						</Paper>
					</Fade>
				</ClickAwayListener>
			</TrapFocus>
		);
	}
	
	
	function reloadParkingCapacity() {
		setCounter(60);
		refetch();
	}
	
	useEffect(() => {
		return () => {
		
		};
	}, []);
	return (
		<>
			{/*<Dialog*/}
			{/*	open={dialogOpen}*/}
			{/*	TransitionComponent={Transition}*/}
			{/*	keepMounted*/}
			{/*	onClose={handleClose}*/}
			{/*	aria-describedby="alert-dialog-slide-description"*/}
			{/*>*/}
			{/*	<DialogTitle>{'Use Google\'s location service?'}</DialogTitle>*/}
			{/*	<DialogContent>*/}
			{/*		<DialogContentText id="alert-dialog-slide-description">*/}
			{/*			Let Google help apps determine location. This means sending anonymous*/}
			{/*			location data to Google, even when no apps are running.*/}
			{/*		</DialogContentText>*/}
			{/*	</DialogContent>*/}
			{/*	<DialogActions>*/}
			{/*		/!*<Button onClick={handleClose}>Disagree</Button>*!/*/}
			{/*		/!*<Button onClick={handleClose}>Agree</Button>*!/*/}
			{/*	</DialogActions>*/}
			{/*</Dialog>*/}
			
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					flexDirection: 'column',
					'& [tabindex]:focus': {outline: '1px solid #0755e4'}
				}}
			>
				{dialogOpen && (
					<ModalDialog/>
				)}
			</Box>
			<Snackbar
				open={snackLocationNotFound()}
				anchorOrigin={{vertical: 'top', horizontal: 'center'}}
				autoHideDuration={10000}
				onClose={handleSnackClose}
				// TransitionComponent={TransitionUp}
				className="flex justify-center text-center mt-28"
				ContentProps={{
					sx: {
						display: 'block',
						textAlign: 'center'
					}
				}}
			>
				<Alert onClose={handleSnackClose} severity="warning" sx={{width: '100%'}}>
					{t(`parking.no_location_found`)}
				</Alert>
			</Snackbar>
			{/*{map ? <DisplayPosition map={map}/> : null}*/}
			{/*{displayMap}*/}
			<MapContainer
				// @ts-ignore
				// ref={mapRef}
				// ref={setMap}
				center={latLng}
				zoom={zoom}
				zoomControl={false}
				scrollWheelZoom={true}
				doubleClickZoom={true}
				className="map_new markercluster-map h-[calc(100vh-140px)]"
				// whenReady={() => {
				// 	// mapRef.fly
				// 	console.log("This function will fire once the map is created")
				// }}
				// @ts-ignore
				whenReady={({target: map}) => {
					setTimeout(() => {
						setMap(map);
						setMapLoaded(true);
						// can use `map.getBound()` without error here
						// map.flyTo([36.27819926, 59.61723447], map.getZoom());
					}, 100);
				}}
			>
				<Control prepend={true} position="topleft">
					<ZoomControl/>
				</Control>
				{/*<Control prepend={true} position="topright">*/}
				<LayersControl position="topright">
					{/*<LayersControl.BaseLayer checked name="Map">*/}
					{/*	<TileLayer*/}
					{/*		attribution="Rezvan"*/}
					{/*		url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"*/}
					{/*	/>*/}
					{/*</LayersControl.BaseLayer>*/}
					{layersMap.map((layer, index) => {
						return (
							<BaseLayer
								key={index}
								checked={index === 0}
								name={t(`parking.layers.${layer.name}`)}
							>
								<TileLayer
									attribution={layer.attribution}
									url={layer.url}
								/>
							</BaseLayer>
						);
					})}
				</LayersControl>
				{/*</Control>*/}
				<Control prepend={false} position="bottomleft">
					{
						counter == 0 && (
							<div className="w-28">
								<Button
									size="small"
									className="border-0 bg-[#0051de] text-white px-5 py-1 rounded-md w-28"
									onClick={reloadParkingCapacity}
								>
									<Typography sx={{
										color: 'gray.600',
										fontSize: (theme) => theme.typography.fontSize - 3,
										fontWeight: 'bold'
									}}>
										{t('parking.reload')}
									</Typography>
								</Button>
							</div>
						)
					}
				</Control>
				<Control prepend={false} position="bottomleft">
					<div className="parkingLotCapacity flex flex-col bg-[#ffffffe6] p-1 text-center w-28">
						<Typography sx={{
							color: 'gray.600',
							fontSize: (theme) => theme.typography.fontSize - 3,
							fontWeight: 'bold'
						}}>
							{t('parking.parking_capacity')}
						</Typography>
						{
							Object.keys(colors).reverse().map((color) => {
								return (
									<div key={colors[color]['text']}
									     className="flex flex-row mt-2 gap-2 justify-start align-middle items-center">
										<i className={`${colors[color]['class']} rounded h-2`}></i>
										<Typography sx={{
											color: 'gray.600',
											fontSize: (theme) => theme.typography.fontSize - 3,
											fontWeight: 'bold'
										}}>
											{t(`parking.${colors[color]['text']}`)}
										</Typography>
									</div>
								);
							})
						}
					</div>
				</Control>
				<Control prepend={false} position="bottomright">
					<>
						<div className={`cursor-pointer`} onClick={flyToShrine}>
							{/*<ShrineIcon/>*/}
							<ShareLocationIcon/>
						</div>
						<div
							className={`flex flex-col justify-center items-center relative right-[15px] bottom-1 cursor-pointer rounded-3xl w-10 h-10 ${theme.palette.mode === 'light' ? 'bg-gray-100' : 'bg-gray-100'}`}
							onClick={() => setShowParkingLots(!showParkingLots)}>
							<ParkingLotsLayer/>
						</div>
						<div
							className={`flex flex-col justify-center items-center relative right-[15px] bottom-1 cursor-pointer rounded-3xl w-10 h-10 mt-2 ${theme.palette.mode === 'light' ? 'bg-gray-100' : 'bg-gray-100'}`}
							onClick={ShowBoundsArea}>
							<CenterFocusWeakIcon sx={{color: '#636363'}}/>
						</div>
						<div className="cursor-pointer" onClick={showLiveLocation}>
							{
								liveFound > 0 ? (<LocationOn/>) : (<LocationOff/>)
							}
						</div>
					
					</>
				</Control>
				<ImamRezaShrineLocation location={imamRezaShrine} markerClicked={markerClicked}/>
				{
					parkingLot ? (
						<ParkingLocation location={parkingLot} markerClicked={markerClicked}/>
					) : null
				}
				{
					liveFound > 0 ? (
						<LiveLocation markerClicked={markerClicked}/>
					) : null
				}
				{
					showParkingLots ? (
						<ParkingLotsOnMap parkingLotsFilter={parkingLotsFilter} showControl={showParkingLots}/>
					) : null
				}
				{/*<Control position='topright'>*/}
				{/*	<Stack direction='column' spacing={2} >*/}
				{/*		<Button color='inherit'>*/}
				{/*			<AddIcon />*/}
				{/*		</Button>*/}
				{/*		<Button color='inherit'>*/}
				{/*			<DeleteIcon />*/}
				{/*		</Button>*/}
				{/*	</Stack>*/}
				{/*</Control>*/}
				{/*<Control prepend position='topright'>*/}
				{/*	<Button color='inherit'>*/}
				{/*		<SearchIcon />*/}
				{/*	</Button>*/}
				{/*</Control>*/}
				{/*<LocationMarker/>*/}
				{/*<Circle center={position} radius={200} pane="my-existing-pane" />*/}
				{/*<Pane name="custom" style={{zIndex: 100}}>*/}
				{/*</Pane>*/}
				{/*<LocationMarker/>*/}
			</MapContainer>
		</>
	);
};
export default MapComponent;
